import {
  ACTIVE_VIEW_COUNTRY,
  ACTIVE_VIEW_STATE,
  DATE_FORMAT,
} from "../../utils/Constants.tsx";
import { useMap } from "react-leaflet";
import React, { useEffect, useState } from "react";
import L from "leaflet";
import { paths } from "../../services/ServiceConstants.tsx";

interface WMSProps {
  wmsStyle: string;
  activeView: string;
  selectedFilters: any;
  computedDate: string;
  forecastDate: string;
  setWMSTileLayer: (value: any) => void;
  setIsLoading: (data: boolean) => void;
  setShowLegend: (data: boolean) => void;
  setMapClickedInfo: (value: any) => void;
  onWMSLoadComplete: () => void;
  clearLayers: (map: any) => void;
}

const WmsLayer = ({
  wmsStyle,
  activeView,
  selectedFilters,
  setWMSTileLayer,
  computedDate,
  forecastDate,
  setIsLoading,
  setShowLegend,
  setMapClickedInfo,
  onWMSLoadComplete,
  clearLayers,
}: WMSProps) => {
  const map = useMap();
  const [isLayerAdded, setIsLayerAdded] = useState(false);

  useEffect(() => {
    if (map) {
      map.on("click", (e) => {
        if (setMapClickedInfo) setMapClickedInfo(e?.latlng);
      });
    }
  }, [map]);

  const addWmsLayer = () => {
    clearLayers(map);
    let wmsParams = {
      SERVICE: "WMS",
      VERSION: "1.1.1",
      REQUEST: "GetMap",
      FORMAT: "image/png",
      TRANSPARENT: "true",
      STYLES: "",
      LAYERS: "kshema_weather:forecast_rf_layer",
      EXCEPTIONS: "application/vnd.ogc.se_inimage",
      VIEWPARAMS: `data_source_type_id:3;location_type:KSHEMA_0.065;computed_date:${computedDate};forecast_date:${forecastDate}`,
      SRS: "EPSG:4326",
      WIDTH: "769",
      HEIGHT: "737",
      BBOX: "65.60021034667969,5.439077534179688,99.37049277832031,37.80310996582031",
    };

    let wmsLayer = null
    if (wmsLayer) {
      wmsLayer?.setParams(wmsParams);
    } else {
      wmsLayer = L.tileLayer.wms(paths.WEATHER_WMS_URL, wmsParams);
      const stopLoading = () => {
        onWMSLoadComplete();
         setIsLayerAdded(true);
      };
      wmsLayer.addTo(map);
      setWMSTileLayer(wmsLayer);
      wmsLayer.on("load", stopLoading);
    }
  };
  useEffect(() => {
    if (map && selectedFilters) {
      addWmsLayer();
    }
  }, [map, selectedFilters, forecastDate]);

  return null;
};

export default WmsLayer;
